import type { CheckoutSessionsResponse } from '../../services/commonCheckout/types/CheckoutSessionsResponse';
import type { ManufacturerCardTypeConfig } from '../../shared/types/CardCategories/CardCategoriesConfig';
import type { MedicationOption } from '../../shared/types/CardCategories/MedicationOption';

import { getCardCategories } from './selectors';

export const getMedicationOptionsFromManufacturerCardTypeConfig = (
  initialSessionData: CheckoutSessionsResponse,
): MedicationOption[] => {
  const cardCategories = getCardCategories(initialSessionData);

  if (!cardCategories || !Array.isArray(cardCategories)) {
    return [];
  }

  const manufacturerCardCategory = cardCategories.find(
    (category): category is ManufacturerCardTypeConfig =>
      category.type === 'MANUFACTURER_CARD',
  );

  if (!manufacturerCardCategory) {
    return [];
  }

  return manufacturerCardCategory.medications;
};
